app.filter('money', [function () {
    return function (d) {
		var curTpl = '';

		if(customCurrency){
			curTpl = "{{money}} " + customCurrency;
		}else if ( gym[0].Culture ) {
			if (gym[0].Culture == 'bg-BG') {
				curTpl = "{{money}} лв.";
				// $scope.customCurrency = 'лв.';
			}else if(gym[0].Culture.includes('-ES') || gym[0].Culture.includes('pt') || gym[0].Culture.includes('it') || gym[0].Culture.includes('ro') ){
				curTpl = "{{money}}€";
				// $scope.customCurrency = 'eur';
			}else if(gym[0].Culture == "fr-CH"){
				curTpl = "CHF{{money}}";
				// $scope.customCurrency = 'CHF';
			}else if(gym[0].Culture.includes('-GB')){
				curTpl = "£{{money}}";
			}else if(gym[0].Culture == "en-ZA"){
				curTpl = "R{{money}}";
			}else {
				curTpl = "${{money}}";
				// $scope.customCurrency = '$';
			}
		}

        function formatPrice(num) {
            if (num == 0) return '0.00';
			if (num){
				num = parseFloat(num);
				return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
			}

            return '';
        }
        return curTpl.replace("{{money}}", formatPrice(d))
    }
}]);